import { Injectable } from '@angular/core';

/**
 * 操作html5的localStorage,作为缓存数据处理
 */
@Injectable()
export class StorageService {

    constructor() { }

    static set(key:string,value: any){  //存储单个属性
          localStorage[key]=value;
    }
    static get(key : string ,defaultValue:any){//读取单个属性
          return localStorage[key] || defaultValue;
    }

    static setJson(key: string, value: any) {//存储Json对象
        localStorage.setItem(key, value);
    }

    static setObj(key: string, value: any) {//存储对象，以JSON格式存储
        if (value) {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    }

    static getObj(key: string){  //读取对象
        let value: string = localStorage.getItem(key);

        if (value && value != "undefined" && value != "null") {
            return JSON.parse(value);
        }
        return null;
    }

    /**清空localStorage */
    static localStorageClear(){
        localStorage.clear();
    }

    /**清空localstorage，除了currentVersionCode和latestVersionCode 本地和服务器上apk版本号的缓存 */
    static localStorageClearExcludeApkVersion(){
        let currentVersionCode:any;
        let latestVersionCode:any;
        currentVersionCode = localStorage.getItem("currentVersionCode");
        latestVersionCode = localStorage.getItem("latestVersionCode");
        localStorage.clear();
        if(currentVersionCode == null || currentVersionCode== undefined){
            currentVersionCode='';
        }
        if(latestVersionCode == null || latestVersionCode== undefined){
            latestVersionCode='';
        }
        localStorage.setItem("currentVersionCode", currentVersionCode);
        localStorage.setItem("latestVersionCode", latestVersionCode);
    }

    static remove(key: string) {
        localStorage.removeItem(key);
    }

    static clear() {
        sessionStorage.clear();
    }

  write(key:string, value:any) {
    if (value) {
      value = JSON.stringify(value);//将value对象转换成字符串
    }
    localStorage.setItem(key, value);
  }

  read(key:string) {
    let value = localStorage.getItem(key);
    if (value && value != "undefined" && value != "null") {
      return JSON.parse(value);//如果有值则返回value对象
    }
    return null;//没有值则返回空
  }
}



// WEBPACK FOOTER //
// ./src/providers/service/storageservice.ts